import { Dispatch, SetStateAction } from "react";

import { IncompleteCycleCountsResponse, VariantFrontendDto } from "~/types/api";

import CycleCountsTable from "./CycleCountsTable";
import CycleCountsTableV2 from "./CycleCountsTableV2";

export type CycleCountsTableProps = {
  cycleCountData: IncompleteCycleCountsResponse;
  cycleCountVariantData: VariantFrontendDto[];
  selectedRows: {
    cycleCountId: string;
    variantId: string;
    binCount: number;
  }[];
  setSelectedRows: Dispatch<
    SetStateAction<
      {
        cycleCountId: string;
        variantId: string;
        binCount: number;
      }[]
    >
  >;
  isLoadingData: boolean;
  totalPageCount: number;
  page: number;
};

type CycleCountsTableWrapperProps = CycleCountsTableProps & {
  hasCycleCountsTableV2EnhancedFlag?: boolean;
};

const CycleCountsTableWrapper = (props: CycleCountsTableWrapperProps) => {
  const { hasCycleCountsTableV2EnhancedFlag = false, ...tableProps } = props;

  if (hasCycleCountsTableV2EnhancedFlag) {
    return <CycleCountsTableV2 {...tableProps} />;
  }

  return <CycleCountsTable {...tableProps} />;
};

export default CycleCountsTableWrapper;
